import { Injectable } from '@angular/core';

import { CamLazyTranslationService } from '@camelot/translation';

@Injectable({
  providedIn: 'root',
})
export class CamTranslationProject extends CamLazyTranslationService {
  constructor() {
    super('project');
  }
}
